import styled from '@emotion/styled';

export const Table = styled.table`
  width: 100%;
`;

export const TableRow = styled.tr`
  td:first-of-type {
    width: 25%;
  }
`;
